var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle2A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type4_x5F_hair:_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M328,66.5L328,66.5L328,66.5C328.1,66.3,328.1,66.3,328,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M436,109.5c-0.8-7.4-4-15.4-8-21.5c-2.7,5.1-4.4,7.6-7.8,11.5c1.9-15.9-10.1-31.5-23.7-32.6 c3.9,5.5,1.1,16.5-6.1,21.5l-0.1,0.1c7-12.1-1-24.5-9.9-27.2c-0.1,0-0.2-0.1-0.4-0.1c1.6,7.4-4.2,16.3-9.6,20.7 c0.3-11.7-13.3-22.4-25.4-23c-1.9-0.1-3.7,0.1-5.4,0.5c0,0.1,0,0.2,0,0.4c1,11.7-7.4,22.7-12.3,25.4c-0.6-2.9-1-6.6-0.9-10.4 c0.1-2.9,0.5-5.9,1.5-8.4c-14.4,3.1-25.6,21.3-27,34.6l0,0c-2.5-1.5-5.1-8.8-4-13.4c-15.5,12.7-21.5,36-13.9,54.5 c8.5,20.7,34.1,24,55.5,19.2c1.2-0.3,2.3-0.4,3.5-0.5c2.7-0.2,5.2,0,7.6,0.4c4.9,0.8,9.5,2.4,14.7,3c1.8,0.2,3.6,0.4,5.5,0.3 c0.7,0,1.3-0.1,2-0.1c1.7-0.2,3.3-0.4,5-0.8c2-0.4,4-0.8,6.1-1.1c1.6-0.3,3.2-0.5,4.8-0.6c0.2,0,0.4,0,0.5,0 c2.9-0.1,5.9,0.1,8.8,0.1c3.1,0.1,6.2,0,9.2-0.6c7.6-1.6,19-6.8,24.6-17.4C436.8,132.6,437.4,122.6,436,109.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M321.1,84.9c1.4-3.4,3.2-6.8,5.3-10c0.1-2.9,0.5-5.9,1.5-8.4c-14.4,3.1-25.6,21.3-27,34.6l0,0 c2.5,25,16.3,50.1,41,59.7c2.7-0.2,5.2,0,7.6,0.4C323.5,146.5,311.3,113.1,321.1,84.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M328,66.5L328,66.5L328,66.5C328.1,66.3,328.1,66.3,328,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M363.6,98.4c0.7-2.7,1.3-5.3,1.8-7.8c0.1-2.3,0-4.6-0.3-7.2c-1.4-11-9.6-20.2-19.8-24.3 c-0.1,0-0.2-0.1-0.3-0.1c-1.9-0.1-3.7,0.1-5.4,0.5c0,0.1,0,0.2,0,0.4c31.5,12.4,8.9,45.6,9.1,67.9c-0.1,3.1,0,6.1,0.3,9.1 c1.1,11,5.3,20.9,15.4,27.3c1.8,0.2,3.6,0.4,5.5,0.3c0.7,0,1.3-0.1,2-0.1C348.8,149.7,357.1,119.6,363.6,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M408.7,95.3c-1-3.2-2.2-6.3-3.7-9.3c0.8,3.1,1.4,6.1,1.8,9.2c1.4,23.6-5.3,46.9-19,66.7 c0.2,0,0.4,0,0.5,0c2.9-0.1,5.9,0.1,8.8,0.1C410.7,142.9,416,117.5,408.7,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M382.9,139.9c-2-8.7-4.9-17.6-3.3-26.9c1.5-8.6,6.2-16.9,10.8-24.6l-0.1,0.1c7-12.1-1-24.5-9.9-27.2 c9.3,11.7-2.2,27.4-5.5,39.2c-0.6,2.4-1.1,4.8-1.5,7.2c-1,7.3-0.6,14.8,1.4,21.7c0.8,3.1,1.8,6.2,2.6,9.3 c2.3,8.5,3.7,16.9-0.4,24.7c2-0.4,4-0.8,6.1-1.1C385.9,156,383.9,144.4,382.9,139.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle2A);
export default __webpack_public_path__ + "static/media/man_hairstyle_2a.bde42a18e0810bde405d6ec78287dae8.svg";
export { ForwardRef as ReactComponent };